<template>
  <div class="row">
    <div class="input-group">
      <input
        type="text"
        autocomplete="off"
        id="textHesabCode"
        v-bind:maxlength="levelNumber"
        class="form-control form-control-sm rounded-0 text-center"
        :class="{ invalid: newNAccCode_NCode_Invalid }"
        style="direction: ltr"
        v-model="newNAccCode_NCode"
        v-on:focus="$event.target.select()"
        v-on:keydown="onlyNumberAndFilterHesabCode"
        v-bind:placeholder="setPlaceHolder"
      />
      <div class="input-group-prepend rounded-0">
        <span
          class="input-group-text input-group-box-size rounded-left white-text"
          v-bind:class="getbgColor()"
        >
          <a v-on:click="ShowModal()">
            <i class="fas fa-bars fa-sm" aria-hidden="true"></i>
          </a>
          <keep-alive>
            <modal-hesab-code
              v-if="isShowModalHesabCode"
              v-on:HideModal="HideModalHesabCode"
              v-bind:modalName="objName"
              v-bind:levelNumber="levelNumber"
            ></modal-hesab-code>
          </keep-alive>
        </span>
      </div>
    </div>
    <span 
      class="w-100 text-right h8" 
      v-bind:class="gettextColor()"
      v-if="showDesc"
    >
      {{ getHesabNameByNewOrEditRow(newNAccCode_NCode) }}
    </span>
    <filter-hesab-code
      v-if="isShowFilterHesabCode"
      v-bind:HesabCode="newNAccCode_NCode"
      v-bind:levelNumber="levelNumber"
      v-on:HideFilterHesab="HideModalHesabCode"
    ></filter-hesab-code>
  </div>
</template>

<script>
import ModalHesabCode from "./AccCodeComponents/ModalHesabCode.vue";
import FilterHesabCode from "./AccCodeComponents/FilterHesabCode.vue";
import { BusEvent } from "../../../../../main.js";

export default {
  name: "AccCode",
  props: { 
    objName: {type: String, default: "modal-hesab-code"},
    bgColor: { type: String, default: "bg-danger" },
    textColor: {type: String, default: "text-info"},
    setPlaceHolder: { type: String, default: "... از کد حساب"},
    levelNumber: {type: Number, default: 3},
    showDesc: {type: Boolean, default: true}
  },
  components: {
    // کامپاننت مودال کد حساب
    "modal-hesab-code": ModalHesabCode,
    // کامپاننت لیست کشویی کد حساب
    "filter-hesab-code": FilterHesabCode,
  },
  data() {
    return {
      // اطلاعات کد حساب
      newNAccCode_NCode: "",
      newNAccCode_NCode_Invalid: false,
      // تاخیر در تایمر
      setTimeoutDelay: 200,
      // کنترل وضعیت نمایش مودال حساب
      isShowModalHesabCode: false,
      // کنترل وضعیت نمایش لیست کشویی کد حساب
      isShowFilterHesabCode: false,
    };
  },
  watch: {
    newNAccCode_NCode: function (value) {
      if (value != 0 && value != "") {
        // this.isShowFilterHesabCode = true;
      } else {
        this.isShowFilterHesabCode = false;
      }
    },
  },
  methods: {
    // دریافت نام کلاس رنگ متن از والد
    gettextColor() {
      return this.textColor;
    },
    // دریافت نام کلاس رنگ پس زمینه از والد
    getbgColor() {
      return this.bgColor;
    },
    // مخفی کردن لیست کشویی کد حساب
    HideFilterModal() {
      this.isShowFilterHesabCode = false;
    },
    // درج فقط عدد مجاز است
    onlyNumberAndFilterHesabCode($event) {
      if ($event.key === "Backspace") {
        this.isShowFilterHesabCode = true;
      } else if ($event.key === "+") {
        this.ShowModal();
        return $event.preventDefault();
      } else {
        if (!/\d/.test($event.key)) {
          return $event.preventDefault();
        } else {
          this.isShowFilterHesabCode = true;
          // ریست اعتبارسنجی
          this.newNAccCode_NCode_Invalid = false;
        }
      }
    },
    // نمایش مودال کد حساب
    ShowModal() {
      // مخفی کردن کادر لیست حساب
      this.HideFilterModal();
      this.isShowModalHesabCode = true;
      setTimeout(() => {
        // $("#modal-hesab-code").modal("show");
        $("#" + this.objName).modal("show");
        // فیلتر لیست بر اساس مقدار درج شده کاربر
        BusEvent.$emit("setFocusetextHesabSearch", this.newNAccCode_NCode);
      }, this.setTimeoutDelay);
    },
    // دریافت نام حساب از روی کد حساب در هنگام درج سطر جدید
    getHesabNameByNewOrEditRow(NAccCode) {
      if (NAccCode != 0 && NAccCode != "") {
        var TbBaseAccName = this.$store.getters.getAllTbBaseAccDataName(NAccCode);
        if (TbBaseAccName.SDesc != "") {
          // ریست اعتبارسنجی
          this.newNAccCode_NCode_Invalid = false;
          return TbBaseAccName.SDesc;
        } else {
          // فعالسازی اعتبارسنجی
          this.newNAccCode_NCode_Invalid = true;
          return "...";
        }
      } else {
        // ریست اعتبارسنجی
        this.newNAccCode_NCode_Invalid = false;
        return "...";
      }
    },
    // بسته شدن مودال کد حساب
    HideModalHesabCode(event) {
      if (event.NCode != 0) {
        // دریافت کد حساب از مودال
        this.newNAccCode_NCode = event.NCode;
        this.$emit("SelectNAccCode", this.newNAccCode_NCode);
      }
      // مخفی کردن کادر لیست حساب
      this.HideFilterModal();
    },
    checkBlur() {
      console.log("blur");
      this.$el.blur();
    },
    showFocus() {
      console.log("focus");
      this.$el.focus();
    },
  },
};
</script>

<style scoped>
/* استایل اعتبارسنجی */
.invalid {
  border: 1px solid red !important;
  box-shadow: 0 0 5px red !important;
  background-color: rgb(255, 242, 56) !important;
}
</style>


// WEBPACK FOOTER //
// src/pages/AdminPanel/Components/PublicComponents/AccCode/AccCode.vue